module.exports = __webpack_public_path__ + "media/recipes/101-70c9c6e0.png";